import { initLayout } from '../layout.js';

// Competencies are prerendered at build time for SEO.
initLayout();
